// extracted by mini-css-extract-plugin
module.exports = {"Container":"BigLoader_Container__1YjEV","Displayed":"BigLoader_Displayed__1MP6Z","Preloader":"BigLoader_Preloader__1VsOI"};